/**
 * Opens the team stats modal (popup) when clicked. Use for team/doubles names across the app.
 */

import React from 'react';
import { useStatsModal } from '../contexts/StatsModalContext';

export default function TeamStatsLink({ playerIds, children, className }) {
  const { openTeamStatsModal } = useStatsModal();
  const ids = Array.isArray(playerIds) ? playerIds.filter(Boolean) : [];
  if (ids.length === 0) return <>{children}</>;
  return (
    <button
      type="button"
      onClick={() => openTeamStatsModal(ids)}
      className={className || 'team-stats-link'}
    >
      {children}
    </button>
  );
}
